import React, { useCallback, useMemo, useRef, useState } from 'react'

import { useRecordEditManagerContext } from 'features/records/useRecordEditManagerContext'
import { useListViewContext } from 'features/views/ListView/useListViewContext'

import { CreateTaskModal } from './CreateTaskModal'
import { DeleteRecordConfirmModal } from './DeleteRecordConfirmModal'
import { ActionMenuContext } from './useActionMenuContext'

type ActionMenuContextProviderProps = {}

export const ActionMenuContextProvider: React.FC<ActionMenuContextProviderProps> = ({
    children,
}) => {
    const [deleteModalRecord, setDeleteModalRecord] = useState<RecordDto | undefined>()
    const isDeleteModalOpen = !!deleteModalRecord
    const onDeleteModalOpenChange = useCallback((open: boolean) => {
        if (!open) setDeleteModalRecord(undefined)
    }, [])

    const setDeleteModalRecordSid = useCallback((recordSid: string) => {
        const records = recordsRef.current
        const record = records.find((r) => r._sid === recordSid)
        if (record) setDeleteModalRecord(record)
    }, [])

    const [createTaskRecord, setCreateTaskRecord] = useState<RecordDto | undefined>()
    const isCreateTaskModalOpen = !!createTaskRecord
    const onCreateTaskModalOpenChange = useCallback((open: boolean) => {
        if (!open) setCreateTaskRecord(undefined)
    }, [])

    const { stack } = useListViewContext()
    const { records } = useRecordEditManagerContext()!
    const recordsRef = useRef(records)
    recordsRef.current = records

    const createTaskForRecord = useCallback((recordSid: string) => {
        const records = recordsRef.current
        const record = records.find((r) => r._sid === recordSid)
        if (record) setCreateTaskRecord(record)
    }, [])

    const value = useMemo(
        () => ({
            deleteRecord: setDeleteModalRecordSid,
            createTaskForRecord: createTaskForRecord,
        }),
        [createTaskForRecord, setDeleteModalRecordSid]
    )

    return (
        <ActionMenuContext.Provider value={value}>
            {children}
            <DeleteRecordConfirmModal
                record={deleteModalRecord}
                isOpen={isDeleteModalOpen}
                onOpenChange={onDeleteModalOpenChange}
            />
            <CreateTaskModal
                record={createTaskRecord}
                onOpenChange={onCreateTaskModalOpenChange}
                stackSid={stack._sid}
                isOpen={isCreateTaskModalOpen}
            />
        </ActionMenuContext.Provider>
    )
}
